import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Settings } from 'lucide-react'

export default function AdminSystemSettings() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">ตั้งค่าระบบ</h1>
        <p className="text-muted-foreground">การตั้งค่าและการกำหนดค่าระบบ</p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Settings className="h-5 w-5" />
            การตั้งค่าระบบ
          </CardTitle>
          <CardDescription>ส่วนนี้อยู่ระหว่างการพัฒนา</CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground">
            ระบบการตั้งค่ากำลังอยู่ระหว่างการพัฒนา<br />
            จะสามารถตั้งค่าระบบ จัดการการแจ้งเตือน และกำหนดค่าต่างๆ ได้ในอนาคต
          </p>
        </CardContent>
      </Card>
    </div>
  )
}
